import React, { useEffect, useState } from 'react';
import bell from '../../../assets/dashboard/bell.png';
import bg from '../../../assets/dashboard/bg.jpg';
import blue from '../../../assets/dashboard/blue.png';
import coursecard from '../../../assets/dashboard/coursecard.svg';
import dot from '../../../assets/dashboard/dot.png';
import dummyImage from '../../../assets/dashboard/DummyImage.jpg';
import green from '../../../assets/dashboard/green.png';
import percentage from '../../../assets/dashboard/percentage.png';
import rates from '../../../assets/dashboard/rates.png';
import soldProducts from '../../../assets/dashboard/soldproducts.png';
import userImage from '../../../assets/dashboard/userimage.png';
import newsImg from '../../../assets/dashboard/news.png';
import groupRight from '../../../assets/dashboard/green.png';
import certIcon from '../../../assets/dashboard/coursecard.svg';
import logo from '../../../assets/dashboard/Eb-logo.svg'
import iconImage from '../../../assets/policy/Eb-logo-icon.svg'
import DashboardCharts from './DashboardCharts';

import './dashboard.css'
import { getMyDashboardData } from '../../../services/Staff/Staff';
import NewsCard from './news-card';
import CoursesComponent from '../profile/CoursesComponent';


const StaffDashboard = () => {

  const [dashboardData, setDashboardData] = useState();
  const [loading , setLoading] = useState(false)

  const fetchData = async () => {
    setLoading(true)
    const data = await getMyDashboardData();
    if (data) {
      console.log("admin profile data >>>", data);
      setDashboardData(data);
    }
    setLoading(false)
  };

  useEffect(() => {
    fetchData();
  }, []);


  return (
    <div className="col-md-12 main_area dashboard-main-container">
      {
        loading ?
          <div className="col-md-12" style={{ height: '40vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div class="spinner-border spinner-border-sm" role="status"></div>
          </div>
        :
        <>
        <div className="row four_colums">
        <div className="col-md-3">
          <div className="image_box">
            <div className="content_box">
              <div className="dot_title">
                <img src={dot} alt="dot" className="dot" />
                <p className='ps-2'>Products Sold</p>
              </div>
              <h4 className="mt-2">{dashboardData?.productSolds}</h4>
            </div>
            <div className="img_icon">
              <img src={soldProducts} alt="sold products" />
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="image_box">
            <div className="content_box">
              <div className="dot_title">
                <img src={green} alt="dot" className="dot" />
                <p className='ps-2'>Memberships Sold</p>
              </div>
              <h4 className="mt-2">{dashboardData?.membershipSolds}</h4>
            </div>
            <div className="img_icon">
              <img src={rates} alt="rates" />
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="image_box">
            <div className="content_box">
              <div className="dot_title">
                <img src={blue} alt="dot" className="dot" />
                <p className='ps-2'>Rebooking Rates</p>
              </div>
              <h4 className="mt-2">{dashboardData?.averageRatings}%</h4>
            </div>
            <div className="img_icon">
              <img src={percentage} alt="percentage" />
            </div>
          </div>
        </div>
        <div className="col-md-3">
           <a
                href="https://partners.fresha.com/users/sign-in"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
          <div className="image_box">
            <div className="content_box">
             
                <h2 className="mt-2">Fresha</h2>
              
            </div>
          </div>
          </a>
        </div>
      </div>

      <div className="Graph_section py-5 text-center">
        <DashboardCharts userData={dashboardData} />
        {/* <img src={dummyImage} className="img-fluid" alt="graph" /> */}
      </div>
      {/* <div> */}
      {/* <div className="col-8 col-md-8 col-lg-8 mx-auto"> */}
      <div className="row g-4">
        {dashboardData?.latestFeeds.length > 0 ?
          dashboardData.latestFeeds.slice(0, 2).map((course, idx) => (
            <div className="col-md-4" key={idx}>
              <div style={{ height: '500px' }}>
                <NewsCard post={course} />
              </div>
            </div>
          ))
        :
       <div className="col-md-8"
        style={{
      
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '18px',
      fontWeight: '500',
      gap:'10px'
    }}
       >
        <i className="bi bi-info-circle" style={{ fontSize: '20px' }}></i>
                        No records found
 
</div>
        }

        <div className="col-md-4">
          <div
            className="position-relative d-flex align-items-center justify-content-center"
            style={{
              // height: '500px',
              // padding: '1rem',
              // border: '1px solid #ddd',
              // borderRadius: '8px',
              // backgroundColor: '#fff',
              // textAlign: 'center',
            }}
          >
            {/* Main Logo */}
            <img
              src={logo}
              alt="Logo"
              style={{ height: '500px', }}
            />

            {/* Icon Image on top */}
            <img
              src={iconImage}
              alt="Center Icon"
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                pointerEvents: 'none',
              }}
            />
          </div>
        </div>
      </div>
        </>
      }
      

      {/* </div> */}

      {/* </div> */}

      <div className='my-4'>
        <CoursesComponent />

      </div>

    </div>
  );
};

export default StaffDashboard;
